import styled, { css } from "styled-components";
export const ProductsWrap = styled.section `
	min-width: 1200px;
	margin: 0 auto;
	height: auto;
	position: relative;

	${(props) => {
    if (typeof props.width === "number") {
        return css `
				width: ${props.width}px;
			`;
    }
    return css `
			width: ${props.width || "1200px"};
		`;
}}
`;
export const GridMoreBaseBox = styled.section `
	width: inherit;
	margin: 0 auto;
	display: grid;
	grid-template-areas: "a a .";
	flex-wrap: wrap;

	${(props) => {
    const gap = props.gridGap || 12;
    if (typeof props.width === "number") {
        return css `
				margin-top: ${gap}px;
				grid-gap: ${gap}px;
				grid-template-columns: repeat(auto-fill, ${props.width}px);
			`;
    }
    return css `
			margin-top: ${gap}px;
			grid-gap: ${gap}px;
			width: ${props.width};
		`;
}}

	@supports not (display: grid) {
		display: flex;
		grid-gap: 0;
		${(props) => {
    const gridCol = props.gridCol || 4;
    const gap = props.gridGap || 12;
    return css `
				margin-right: ${gap}px;
				&:nth-child(${gridCol}n + 1),
				&:first-child {
					margin-right: 0;
				}
			`;
}}
	}
`;
export const GridRowOneBox = styled.section `
	width: inherit;
	margin: 0 auto;
	display: flex;
	flex-wrap: wrap;

	${(props) => {
    const gap = props.gridGap || 12;
    return css `
			margin-top: ${gap}px;
			grid-gap: ${gap}px;
		`;
}}

	@supports not (grid-gap: 12px) {
		&:after {
			content: "";
			clear: both;
			height: 0;
			width: 0;
			visibility: hidden;
			display: block;
		}
		${(props) => {
    const gridCol = props.gridCol || 4;
    return css `
				&:nth-child(${gridCol}n + 1),
				&:first-child {
					margin-right: ${props.gridGap}px;
				}
			`;
}}
	}
`;
